import Swiper from 'swiper';
import { EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
const Home = {
  init() {
    const slideshow = document.getElementById('homeSlideShow');
    if (slideshow) {
      new Swiper('#homeSlideShow .swiper', {
        modules: [EffectFade, Autoplay],
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: true,
        },
        speed: 3000,
      });
    }
  },
};

export { Home };
